export const colors = {
  white: "#FFFFFF",
  beige: "#F5F0E8",
  deepBeige: "#EDE8DF",
  navy: "#1B3A6B",
  midNavy: "#2E5FA3",
  powderBlue: "#B8D4E8",
  skyBlue: "#5B9BD5",
  gold: "#C9A84C",
  brightGold: "#E8C547",
  green: "#2E7D32",
  red: "#C0392B",
  darkText: "#1A1A2E",
  bodyText: "#4A4A6A",
  mutedText: "#888888",
};

export function injectTheme() {
  const root = document.documentElement;

  root.style.setProperty("--color-white", colors.white);
  root.style.setProperty("--color-beige", colors.beige);
  root.style.setProperty("--color-deep-beige", colors.deepBeige);
  root.style.setProperty("--color-navy", colors.navy);
  root.style.setProperty("--color-mid-navy", colors.midNavy);
  root.style.setProperty("--color-powder-blue", colors.powderBlue);
  root.style.setProperty("--color-sky-blue", colors.skyBlue);
  root.style.setProperty("--color-gold", colors.gold);
  root.style.setProperty("--color-bright-gold", colors.brightGold);
  root.style.setProperty("--color-green", colors.green);
  root.style.setProperty("--color-red", colors.red);
  root.style.setProperty("--color-dark-text", colors.darkText);
  root.style.setProperty("--color-body-text", colors.bodyText);
  root.style.setProperty("--color-muted-text", colors.mutedText);

  root.style.setProperty("--font-display", "'Playfair Display', serif");
  root.style.setProperty("--font-body", "'DM Sans', sans-serif");

  // Load Google Fonts if not already present
  if (!document.getElementById("forge-sa-fonts")) {
    const link = document.createElement("link");
    link.id = "forge-sa-fonts";
    link.rel = "stylesheet";
    link.href = "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800;900&family=DM+Sans:wght@400;500;600;700;800;900&display=swap";
    document.head.appendChild(link);
  }
}